// @flow
import 'isomorphic-fetch';
import React from 'react';
import Cookies from 'universal-cookie';
import Header from '@ff/ui/Header';
import Header2 from '@ff/ui/Header2';
import { mapLoggedInLabel } from '@ff/ui/Header2/utils';
import { zIndex } from 'shared/constants';
import { IS_APP } from 'shared/lib/pathUtils';
import { styled } from '@ff/ui';
import isIPArabicRegion from 'shared/lib/isIPArabicRegion';
import { getRedirectForAR, getWebDomain } from 'shared/lib/clientSettings';

export default function MenuBar(props) {
  const cookies = new Cookies();
  const isLoggedIn = cookies.get('isLoggedIn') === 'true';

  const {
    version,
    scroll_effect,
    logo_link,
    color_theme,
    drawerLinks,
    logoType,
    transparent,
    float,
    spacer,
    background,
  } = props;
  const isEditor = !!props.editor;

  if (IS_APP) return null;

  /** version 2 */
  if (version == 2) { // version is string
    const url = new URL(window.location.href);

    // Only support redirection for the homepage
    if (isRootPath(url) && !containsArabicPath(url) && !shouldIgnoreRedirect(url, props)) {
      shouldRedirectToArabic().then((redirectToArabic) => {
        if (redirectToArabic) {
          const domain = getWebDomain('US');
          window.location.href = `${domain}/ar/en/`;
        }
      });
    }

    return (
      <Container isEditor={isEditor}>
        <Header2
          scrollEffect={scroll_effect}
          colorTheme={color_theme}
          logoLink={logo_link}
          drawerLinks={mapLoggedInLabel(drawerLinks, isLoggedIn)}
          logoType={logoType}
          zIndex={zIndex.MENU_BAR}
          drawerZIndex={zIndex.MENU_BAR + 1}
          transparent={transparent}
          float={float}
          spacer={spacer}
          background={background}
        />
      </Container>
    );
  }

  /** version 1 */
  return (
    <Container isEditor={isEditor}>
      <Header
        {...props}
        isLoggedIn={isLoggedIn}
        // prevent MenuBar going outside of editor (scroll_effect has position fixed)
        scroll_effect={isEditor ? false : props.scroll_effect}
      />
    </Container>
  );
}

const isRootPath = (url) => {
  return url.pathname === '/';
}

const containsArabicPath = (url) => {
  return url.pathname.includes('/ar/');
}

const shouldIgnoreRedirect = (url, props) => {
  // Ignore redirect when editing
  const isEditing = props.editor;

  // Ignore redirect when previewing
  const valueOfV = url.searchParams.get('v');
  const isDraft = valueOfV === 'DRAFT';

  // Ignore redirect when publishing
  const valueOfPublish = url.searchParams.get('publish');
  const isPreviewPublish = valueOfPublish === 'true';

  // Ignore redirect if the url contains /ar/ segment
  const containsARSegment = url.pathname.includes('/ar/');

  const shouldIgnore = isEditing ||
    isDraft ||
    isPreviewPublish ||
    containsARSegment;

  return shouldIgnore;
}

const shouldRedirectToArabic = async () => {
  try {
    const isRedirectForAREnabled = getRedirectForAR() === 'true';
    const isArabicRegion = await isIPArabicRegion();
    return isRedirectForAREnabled && isArabicRegion;
  } catch (error) {
    console.error('Error checking region:', error);
    return false;
  }
}

const Container = styled.Box(({ isEditor }) => ({
  zIndex: zIndex.MENU_BAR,
  position: 'relative',
  width: '100%',

  /*
    Positioning for the Header under component browser + template browser.
    `position: fixed;` will cause the menu to go outside the edit area.
  */
  '.component-browser-wrapper > & #ff-ui-header, .template-browser-wrapper & #ff-ui-header': {
    position: 'absolute'
  },
  '& #ff-ui-header': isEditor && {
    position: 'absolute'
  },
}));
